<div [hidden]="hidden" nz-row>
  <div nz-col nzXs="24" class="text-align-center margin-bottom">
    <nz-spin nzSimple></nz-spin>
    Loading...
  </div>
</div>